import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { StatesProvincesEntity } from './states-provinces.entity';

@Index('UQ_countries_code', ['code'], { unique: true })
@Entity('countries')
export class CountriesEntity extends BaseEntity {
	@Column('varchar', { name: 'code', length: 2 })
	public code!: string;

	@Column('varchar', { name: 'name', length: 100 })
	public name!: string;

	@Column({
		type: 'boolean',
		name: 'active',
		nullable: true,
		width: 1,
		default: () => "'1'",
	})
	public active!: boolean | null;

	@OneToMany(
		() => StatesProvincesEntity,
		(statesProvinces) => statesProvinces.countryCode2,
		{},
	)
	public statesProvinces!: Array<StatesProvincesEntity>;
}
